(function () {
  function initRotator(root) {
    if (!root || root.dataset.xoInit === "1") return;
    root.dataset.xoInit = "1";

    const items = Array.from(root.querySelectorAll(".xo-rotator__item"));
    if (items.length <= 1) return;

    const interval = Math.max(800, parseInt(root.dataset.interval || "3000", 10));

    let index = items.findIndex((el) => el.classList.contains("is-active"));
    if (index < 0) index = 0;

    function show(nextIndex) {
      const current = items[index];
      const next = items[nextIndex];

      if (current === next) return;

      // Prepare next (start below)
      next.classList.remove("is-exiting");
      next.classList.add("is-active");
      next.setAttribute("aria-hidden", "false");

      // Exit current (move up)
      current.classList.add("is-exiting");
      current.setAttribute("aria-hidden", "true");

      // After transition, reset the old one back to "below"
      window.setTimeout(() => {
        current.classList.remove("is-active");
        current.classList.remove("is-exiting");
      }, 500);

      index = nextIndex;
    }

    const timer = window.setInterval(() => {
      const nextIndex = (index + 1) % items.length;
      show(nextIndex);
    }, interval);

    // If theme editor re-renders sections, avoid orphan intervals
    root.addEventListener("xo:destroy", () => window.clearInterval(timer));
  }

  function initAll() {
    document.querySelectorAll(".xo-rotator").forEach(initRotator);
  }

  document.addEventListener("DOMContentLoaded", initAll);

  // Shopify theme editor events
  document.addEventListener("shopify:section:load", (e) => {
    initAll();
  });

  document.addEventListener("shopify:section:unload", (e) => {
    if (!e.target) return;
    e.target.querySelectorAll(".xo-rotator").forEach((root) => {
      root.dispatchEvent(new CustomEvent("xo:destroy"));
      root.dataset.xoInit = "0";
    });
  });
})();
